import {
  InvitationProcessStatusDTO,
  PaymentMethodDTO,
  PaymentMethodSetupIntent,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type PublicHostedClubApiType = ReturnType<typeof publicHostedClubApi>;
const publicHostedClubApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    findById(id: number) {
      return axiosInstance.get(`${clubPrefix}hosted/settings`);
    },
    invitationRequest({
      email,
      invitationLinkPath,
    }: {
      email: string;
      invitationLinkPath: string;
    }) {
      return axiosInstance.put(
        `${clubPrefix}hosted/invitation-request/${email}`,
        undefined,
        {
          params: {
            invitationLinkPath,
          },
        },
      );
    },
    invitationStatus({ invitationToken }: { invitationToken: string }) {
      return axiosInstance.get<InvitationProcessStatusDTO>(
        `${clubPrefix}hosted/invitation-process/status`,
        {
          params: {
            invitationToken,
          },
        },
      );
    },
    invitationNewPassword({
      invitationToken,
      newPassword,
    }: {
      invitationToken: string;
      newPassword: string;
    }) {
      return axiosInstance.put(
        `${clubPrefix}hosted/invitation-process/new-password`,
        {
          invitationToken,
          newPassword,
        },
      );
    },
    async invitationPaymentMethodSetupIntent({
      invitationToken,
    }: {
      invitationToken: string;
    }) {
      return (
        await axiosInstance.put<PaymentMethodSetupIntent>(
          `${clubPrefix}hosted/invitation-process/${invitationToken}/setup-intent`,
        )
      ).data;
    },
    invitationPaymentMethodSetupIntentAuthorized({
      invitationToken,
      setupIntentId,
    }: {
      setupIntentId: string;
      invitationToken: string;
    }) {
      return axiosInstance.put<PaymentMethodDTO>(
        `${clubPrefix}hosted/invitation-process/${invitationToken}/setup-intent-authorized/${setupIntentId}`,
      );
    },
  };
};

export default publicHostedClubApi;
